export function openModalDriver() {
    const modal = document.getElementById("modalTambahDriver");
    modal.classList.remove("hidden");
}

export function closeModalDriver() {
    const modal = document.getElementById("modalTambahDriver");
    modal.classList.add("hidden");
}
